import { formatDateTime } from "./formatDateTime";
import { timeAgo } from "./timeAgo";

const getAbsoluteLabel = (dateInput) => {
  const formatted = formatDateTime(dateInput);
  if (!formatted) return "";

  return `${formatted.month} ${formatted.day}${formatted.suffix}, ${formatted.year} at ${formatted.time}`;
};

export function formatCommentTimestamp(dateInput) {
  if (!dateInput) return { label: "", title: "" };

  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return { label: "", title: "" };

  const ageMs = Date.now() - date.getTime();
  const absAgeMs = Math.abs(ageMs);
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;
  const absolute = getAbsoluteLabel(dateInput) || date.toLocaleString();

  if (absAgeMs < minuteMs) {
    return { label: "⚡ just now", title: absolute };
  }

  if (absAgeMs < hourMs) {
    return { label: `🌱 ${timeAgo(dateInput)}`, title: absolute };
  }

  if (absAgeMs < dayMs) {
    return { label: `🕒 ${timeAgo(dateInput)}`, title: absolute };
  }

  if (absAgeMs < 7 * dayMs) {
    return { label: `📅 ${timeAgo(dateInput)}`, title: absolute };
  }

  return { label: absolute, title: absolute };
}
